import {
  Organization,
} from "model/organizationModel";
import createContext, { Action } from "./createDataContext";
import { DispatchAction } from "./createDataContext";
import { CONSTANTS } from "common";

const SET_ORGANIZATION_FIRST_SEARCH = "SET_ORGANIZATION_FIRST_SEARCH";
const REMOVE_ORGANIZATION_FIRST_SEARCH = "REMOVE_ORGANIZATION_FIRST_SEARCH";
const SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
const SET_SELECTED_ORGANIZATION = "SET_SELECTED_ORGANIZATION";
const SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION =
  "SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION";

const INITIAL_STATE = {
  organizationsFirstSearch: false as boolean,
  organizations: [] as Organization[],
  selectedOrganization: null as Organization | null,
};

const alignSelectedToLocal = (selectedOrganization: Organization | null) => {
  if (selectedOrganization?.id) {
    localStorage.setItem(
      CONSTANTS.STORE_SELECTED_ORGANIZATION_ID,
      String(selectedOrganization.id),
    );
  } else {
    localStorage.removeItem(CONSTANTS.STORE_SELECTED_ORGANIZATION_ID);
  }
};
const reducer = (state: typeof INITIAL_STATE, action: Action) => {
  switch (action.type) {
    case SET_ORGANIZATION_FIRST_SEARCH: {
      return { ...state, organizationsFirstSearch: true };
    }
    case REMOVE_ORGANIZATION_FIRST_SEARCH: {
      return { ...state, organizationsFirstSearch: false };
    }
    case SET_ORGANIZATIONS: {
      return { ...state, organizations: action.payload };
    }
    case SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION: {
      const { organizations, selectedOrganization } = action.payload;
      alignSelectedToLocal(selectedOrganization);
      return { ...state, organizations, selectedOrganization };
    }
    case SET_SELECTED_ORGANIZATION: {
      const selectedOrganization = action.payload as Organization;
      alignSelectedToLocal(selectedOrganization);
      return { ...state, selectedOrganization: action.payload };
    }
    default: {
      return state;
    }
  }
};

const addOrganizationsFirstSearch: DispatchAction<{}, void> =
  (dispatch) => () => {
    dispatch({ type: SET_ORGANIZATION_FIRST_SEARCH });
  };
const removeOrganizationsFirstSearch: DispatchAction<{}, void> =
  (dispatch) => () => {
    dispatch({ type: REMOVE_ORGANIZATION_FIRST_SEARCH });
  };

const setOrganizations: DispatchAction<Organization[], void> =
  (dispatch) => (organizations) => {
    const localSelectedOrganizationId = localStorage.getItem(
      CONSTANTS.STORE_SELECTED_ORGANIZATION_ID,
    );
    const selectedOrganization = organizations.find(
      (o) => String(o.id) === localSelectedOrganizationId,
    );
    if (selectedOrganization) {
      dispatch({
        type: SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION,
        payload: {
          organizations,
          selectedOrganization,
        },
      });
    } else {
      if (organizations.length > 0) {
        dispatch({
          type: SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION,
          payload: { organizations, selectedOrganization: organizations[0] },
        });
      } else {
        dispatch({ type: SET_ORGANIZATIONS, payload: organizations });
      }
    }
  };
const setSelectedOrganization: DispatchAction<Organization | null, void> =
  (dispatch) => (selectedOrganization) => {
    dispatch({
      type: SET_SELECTED_ORGANIZATION,
      payload: selectedOrganization,
    });
  };

const actions = {
  addOrganizationsFirstSearch,
  removeOrganizationsFirstSearch,
  setOrganizations,
  setSelectedOrganization,
  // ACTIONS
};
type ActionsType = typeof actions;
export type ContextType = {
  state: typeof INITIAL_STATE;
  actions: {
    [Property in keyof ActionsType]: ReturnType<ActionsType[Property]>;
  };
};
export const { Context, Provider } = createContext<
  ContextType,
  typeof INITIAL_STATE,
  typeof actions
>(reducer, actions, INITIAL_STATE);
